import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { PaymentActions } from '@app/core/ngrx/actions';
import { State } from '@app/core/ngrx/reducers';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { PaymentCouponCodeComponent } from '../payment-coupon/payment-coupon.component';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import PaymentApplication from '@Interfaces/PaymentApplication';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { ToolService } from '@app/core/services/tool/tool.service';
import { PaymentNotifyPopupComponent } from '../payment-notify-popup/payment-notify-popup.component';
import { ActivatedRoute } from '@angular/router';
import { isNil } from '@app/shared/utils';
import { LOCALE_ID, Inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-payment-summary',
    templateUrl: './payment-cart-items.component.html',
    styleUrls: ['./payment-cart-items.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, MatTooltipModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentDetailsSummaryComponent implements OnInit {
    // current checkout total
    //
    $paymentCart = this.paymentService.currentCartSubscription;
    //
    cartLength: number = 0;

    currentCart: any[] = [];
    //
    $checkoutType = this.paymentService.currentPaymentMethod;
    //
    // total price of all items in the cart
    $dueToday = this.paymentService.currentCartTotalSubscription;
    //
    faFileInvoiceDollar = faFileInvoiceDollar;
    //
    pendingWire$ = this.paymentService.pendingWireTransfer;
    //
    paymentList$ = this.paymentService.currentPaymentList;
    //
    paymentList: any[];

    cartStatus = {
        length: 0,
        fullPaymentLength: 0,
        finalPaymentLength: 0,
        applicationsStatus: [],
    };

    param: any;

    constructor(
        private paymentService: PaymentService,
        private store: Store<State>,
        private modalCtrl: ModalController,
        public toolService: ToolService,
        private route: ActivatedRoute,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        @Inject(LOCALE_ID) public locale: string
    ) {}

    ngOnInit() {
        this.param = String(this.route.snapshot.queryParamMap.get('chainid'));

        this.paymentList$.subscribe((a) => {
            this.paymentList = [...a];
        });

        this.listenForCartchanges();
    }

    /**
     * @description main listener for cart changes
     */
    listenForCartchanges() {
        //
        let newPayment;
        this.cartStatus.length = 0;
        this.cartStatus.fullPaymentLength = 0;
        this.cartStatus.finalPaymentLength = 0;
        this.cartStatus.applicationsStatus = [];

        this.$paymentCart.subscribe((response: Array<PaymentApplication>) => {
            // console.log('applications', applications);

            if (response.length > 0) {
                //
                this.cartLength = response.length;

                //
                this.currentCart = response.map((i: PaymentApplication) => {
                    return { ...i };
                });
                //
                this.currentCart.forEach((a) => {
                    if (a.paymentType === 'full-payment') {
                        this.cartStatus.fullPaymentLength;
                    }
                });
                //
                this.cartStatus.length = this.currentCart.length;
                //
                this.cartStatus.fullPaymentLength = [...this.currentCart].filter((i) => i.paymentType === 'full-payment').length;
                //
                this.cartStatus.finalPaymentLength = [...this.currentCart].filter((i) => i.paymentType === 'final-payment').length;
                //
                this.cartStatus.applicationsStatus = [...this.paymentList].map((i) => {
                    if (i.applicationChain && i.applicationChain.length > 0) {
                        if (i.applicationChain.some((a) => a.id === this.param)) {
                            return i.states;
                        }
                    }
                });
                //
                //
                let TempCart: PaymentApplication[] = response.map((i) => {
                    return { ...i };
                });

                //

                //
                // collect application amounts based on payment type
                let ApplicationPriceArray = TempCart.map((item: PaymentApplication) => {
                    return item.paymentType === 'first-payment'
                        ? item.firstSubtotalPrice
                        : item.paymentType === 'full-payment'
                        ? item.fullSubtotalPrice
                        : item.finalSubtotalPrice;
                });

                // addon cart price set here
                // addon price array collected from application addon properties
                let AddonPriceArray = TempCart.map((item: PaymentApplication) => {
                    let price = 0;
                    // check for malpractice checked
                    if (item.malpracticeChecked) {
                        price += item.malpracticeAddonPrice;
                    }
                    if (item.switchProtectionChecked) {
                        price += item.switchProtectionAddonPrice;
                    }
                    return price;
                });

                //
                //
                // console.log('PRICE ARRAY BY PAYMENT TYPE: ', PriceArray);
                // console.log('Current Sum: ',PriceArray.reduce(reducer));
                // each cell in array is a sum of the cart item
                let amount: number = [...ApplicationPriceArray, ...AddonPriceArray].reduce(reducer);
                //
                this.paymentService.updateCartTotal = amount;
            } else {
                this.cartLength = response.length;
                this.currentCart = response.map((i) => {
                    return { ...i };
                });
                this.paymentService.updateCartTotal = 0;
            }
        });
    }

    trackByIndex = (index: number): number => index;

    segmentChanged(event: any) {
        // Angulartics Event: paymentDetailsPaymentTypeBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentDetailsPaymentTypeBtnClick', { category: 'Payments', label: event.detail.value });

        //
        this.paymentService.updateCurrentPaymentMethod = event.detail.value;
    }

    /**
     * @description coupon modal
     *
     */
    async openCouponModal() {
        // Angulartics Event: paymentDetailsSummaryHaveCouponBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentDetailsSummaryHaveCouponBtnClick', { category: 'Payments' });

        //
        //
        const couponModal = await this.modalCtrl.create({
            component: PaymentCouponCodeComponent,
            backdropDismiss: false,
        });
        //
        //
        await couponModal.present();
        //
        //
        //
        const couponResult = await couponModal.onDidDismiss();
        //
        if (couponResult.data.result) {
            // this trigger updates the model values and lets backend apply discounts
            // send application ids that are already selected so maintain selections
            let checkedList = couponResult.data.checkedList;
            //
            let checkedListIds: Array<string> = checkedList.map((i: any) => i.applicationid);
            //
            this.store.dispatch(
                PaymentActions.setPaymentListUpdate({
                    paymentUpdate: checkedListIds,
                })
            );
        }
    }

    couponLabeler(coupon_type: string, application_payment_type: string, bundleid: string): string {
        // first payment coupons
        let firstPaymentCheckLength = 0;
        if (this.currentCart.length) {
            firstPaymentCheckLength = [...this.currentCart].filter((a) => {
                return a.paymentType === 'first-payment' && a.applicationChain.length;
            }).length;
        }

        let color = 'secondary';
        //
        if (application_payment_type === 'first-payment') {
            if (coupon_type === 'final-payment' || coupon_type === 'voucher' || coupon_type === 'customer-satisfaction') {
                color = 'secondary';
            } else if (coupon_type === 'full-payment') {
                color = 'disabled';
            } else if (!isNil(bundleid)) {
                if (this.cartStatus.length < 2 && this.cartStatus.applicationsStatus.filter((c) => c === 'Reserved').length <= 1) {
                    color = 'disabled';
                } else {
                    color = 'secondary';
                }
            } else {
                color = 'secondary';
            }
        } else if (application_payment_type === 'full-payment') {
            if (coupon_type === 'customer-satisfaction') {
                color = 'disabled';
            } else if (coupon_type === 'deposit') {
                color = 'disabled';
            } else if (!isNil(bundleid)) {
                if (this.cartStatus.length < 2 && this.cartStatus.applicationsStatus.filter((c) => c === 'Reserved').length <= 1) {
                    color = 'disabled';
                } else {
                    color = 'secondary';
                }
            } else {
                color = 'secondary';
            }
        } else {
            if (coupon_type === 'deposit') {
                color = 'disabled';
            } else if (coupon_type === 'full-payment') {
                color = 'disabled';
            } else {
                color = 'secondary';
            }
        }
        return color;
    }

    couponMessageLabeler(coupon_type: string, application_payment_type: string, bundleid: string): string {
        //
        //
        let message = '';
        //
        //
        if (application_payment_type === 'first-payment') {
            if (coupon_type === 'final-payment' || coupon_type === 'voucher' || coupon_type === 'customer-satisfaction') {
                message = ' - Applied on Final Payment';
            } else if (coupon_type === 'full-payment') {
                message = ' - Only Applied on Full Payment';
            } else if (!isNil(bundleid)) {
                if (this.cartStatus.length < 2 && this.cartStatus.applicationsStatus.filter((c) => c === 'Reserved').length <= 1) {
                    message = ' - Only Applied if at least two or more bundled applications in cart';
                } else {
                    message = ' - Applied on Final Payment';
                }
            } else {
                message = '';
            }
        } else if (application_payment_type === 'full-payment') {
            if (coupon_type === 'customer-satisfaction') {
                message = ' - Only Applied on Final Payment';
            } else if (coupon_type === 'deposit') {
                message = ' - Only Applied on Deposit Payment';
            } else if (!isNil(bundleid)) {
                if (this.cartStatus.length < 2 && this.cartStatus.applicationsStatus.filter((c) => c === 'Reserved').length <= 1) {
                    message = ' - Only Applied if at least two or more bundled applications in cart';
                } else {
                    message = '';
                }
            } else {
                message = '';
            }
        } else {
            message =
                coupon_type === 'deposit' ? ' - Only Applied on Deposit Payment' : coupon_type === 'full-payment' ? ' - Only Applied on Full Payment' : '';
        }
        return message;
    }

    async deleteCoupon(application_id: string, coupon_code: string) {
        //
        //
        const confirm = await this.confirmCouponDelete();
        //

        if (confirm.data === true) {
            this.paymentService.userRemove(application_id, coupon_code).subscribe((response: any) => {
                this.store.dispatch(
                    PaymentActions.setPaymentListUpdate({
                        paymentUpdate: ['update', 'models'],
                    })
                );
            });
        }
    }

    async confirmCouponDelete() {
        // Angulartics Event: paymentApplicationDetailsAddonLearnMoreBtnClick
        // this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsAddonLearnMoreBtnClick', { label: 'malpractice', category: 'Payments' });

        const confirmCouponDelete = await this.modalCtrl.create({
            component: PaymentNotifyPopupComponent,
            backdropDismiss: false,
            cssClass: 'payment-notify-popup',
            componentProps: {
                icon: {
                    name: 'alert',
                    color: 'secondary',
                    class: 'alert-icon',
                    size: 'large',
                },
                messages: [
                    {
                        text: 'You are removing this coupon from your application.',
                        type: 'string',
                        class: 'black-text text-center bold-text',
                    },
                    {
                        text: 'Do you want to continue?',
                        type: 'string',
                        class: 'black-text text-center',
                    },
                ],
                buttons: [
                    {
                        id: 'CouponRemoveDismissBtn',
                        type: 'cancel-delete',
                        text: 'No',
                        fill: 'solid',
                        color: 'secondary',
                    },
                    {
                        id: 'CouponRemoveConfirmBtn',
                        type: 'confirm-delete',
                        text: 'Yes',
                        fill: 'solid',
                        color: 'primary',
                    },
                ],
                application_id: '',
            },
        });

        await confirmCouponDelete.present();
        return await confirmCouponDelete.onDidDismiss();
        //
    }
}

const reducer = (acc: number, curr: number) => acc + curr;
